import React from "react";
import * as R from "ramda";
import { Avatar, List, Checkbox, Tag } from "antd";
import { compose, withProps, withHandlers } from "recompose";
import { useTranslation } from "react-i18next";

import Search from "../../transforms/Search";
import { getOptimizedImage } from "../../../utils/images";

import styled from "styled-components/macro";

const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Users = ({ users, onToggle, ownerId }) => {
  const { t } = useTranslation();

  return (
    !R.isEmpty(users) && (
      <Search data={users}>
        {data => (
          <List
            itemLayout="horizontal"
            dataSource={R.sortWith([
              R.descend(R.propEq("id", ownerId)),
              R.descend(R.prop("selected"))
            ])(data)}
            renderItem={user => (
              <List.Item
                actions={
                  !R.propEq("id", ownerId, user) && [
                    <Checkbox
                      checked={user.selected}
                      onChange={e => onToggle(e.target.checked, user.id)}
                    />
                  ]
                }
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      src={getOptimizedImage(user.avatar)}
                      icon="user"
                      shape="square"
                      size="large"
                    />
                  }
                  title={
                    <NameWrapper>
                      {user.name}
                      {R.propEq("id", ownerId, user) && (
                        <Tag style={{ cursor: "auto", marginLeft: 8 }}>
                          {t("global:creator")}
                        </Tag>
                      )}
                    </NameWrapper>
                  }
                  description={user.email}
                />
              </List.Item>
            )}
          />
        )}
      </Search>
    )
  );
};

const enhacer = compose(
  withProps(
    R.applySpec({
      users: ({ users = [], value = [] }) =>
        R.map(user => R.assoc("selected", R.includes(user.id, value), user))(
          users
        )
    })
  ),
  withHandlers({
    onToggle: ({ onChange, value }) => (selected, user) =>
      onChange(selected ? R.append(user, value) : R.without(user, value))
  })
);

export default enhacer(Users);
